import { Injectable } from "@angular/core";

import { AuthService } from "shared-lib";

@Injectable({ providedIn: "root" })
export class AuthGuard  {

    constructor(
        private authService: AuthService
    ) {}

    canActivate() {

        return this.authService.validateToken();
    }
}
